<template>
    <div class="ah-page company-info-setting">
        <div class="page-header bottom-margin">
            <div class="ah-container ">
                <div class="title-row">
                    <div class="title">
                        <h1>部門管理</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container ">
            <div class="ah-panel">
                <div class="panel-header small">
                    <div class="panel-title">部門管理</div>
                </div>
                <div class="panel-body">
                    <el-collapse v-model="collapse1" class="drag-item-list collapse">
                        <el-collapse-item name="department">
                            <template slot="title">
                                <span class="group-name">部門項目</span>
                            </template>
                            <draggable v-model="departmentList" draggable=".item" @change="updateData" animation="300">
                                <div v-for="dept in departmentList" :key="dept.sno" class="drag-item item">
                                    <span class="name">{{ dept.deP_NAM }}</span>
                                    <el-button v-if="!isQR()" class="item-edit-btn" type="text" @click="openEditDialog('dept', dept)"><i class="el-icon-edit"></i></el-button>
                                </div>
                            </draggable>
                            <el-button v-if="!isQR()" class="bottom-btn" type="primary" @click="openEditDialog('dept')" plain round>新增</el-button>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
        <EditDialog ref="editDialog" v-if="showEditDialog" :visible="showEditDialog" :inputObject="selectedItem" @close="updateList" @delete="deleteItem" />
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import EditDialog from './EditDialog';

export default {
    components: {
        EditDialog,
        draggable,
    },
    data() {
        return {
            showEditDialog: false,
            collapse1: 'department',
            collapse2: 'vendor',
            collapse3: 'outsourcing',
            selectedItemType: '',
            selectedItem: null,
            draggedItem: {},
            departmentList: [],
            vendorList: [],
            outsourcingList: [],
        };
    },
    created() {
        // 取得設定
        this.fetchList();
    },
    methods: {
        fetchList() {
            this.$api({
                url: '/DepartmentSettingPage/GetDepartmentSettings',
                method: 'GET',
            }).then((resp) => {
                this.departmentList = resp.data.departmentSettings;
            });
        },

        async updateData() {
            try {
                await this.$api({
                    url: '/DepartmentSettingPage/UpsertDepartmentSettings',
                    method: 'post',
                    data: {
                        departmentSettings: this.departmentList,
                    },
                });
            } finally {
                this.fetchList();
            }
        },
        openEditDialog(type, obj) {
            this.selectedItemType = type;
            if (obj) {
                this.selectedItem = { sno: obj.sno, name: obj.deP_NAM || obj.catnam };
            } else {
                this.selectedItem = null;
            }

            this.showEditDialog = true;
        },
        updateList(value) {
            if (value) {
                if (this.selectedItemType === 'dept') {
                    if (this.selectedItem) {
                        this.departmentList.forEach((item) => {
                            if (this.selectedItem.sno === item.sno) item.deP_NAM = value;
                        });
                    } else {
                        this.departmentList.push({ sno: null, deP_NAM: value, sot: 0 });
                    }
                } else if (this.selectedItemType === 'vendor') {
                    if (this.selectedItem) {
                        this.vendorList.forEach((item) => {
                            if (this.selectedItem.sno === item.sno) item.catnam = value;
                        });
                    } else {
                        this.vendorList.push({ sno: null, catnam: value, sot: 0 });
                    }
                } else if (this.selectedItemType === 'outsourcing') {
                    if (this.selectedItem) {
                        this.outsourcingList.forEach((item) => {
                            if (this.selectedItem.sno === item.sno) item.catnam = value;
                        });
                    } else {
                        this.outsourcingList.push({ sno: null, catnam: value, sot: 0 });
                    }
                }
            }

            this.showEditDialog = false;
            this.updateData();
        },
        deleteItem(value) {
            if (value) {
                if (this.selectedItemType === 'dept') {
                    this.departmentList = this.departmentList.filter((x) => x.deP_NAM !== value);
                } else if (this.selectedItemType === 'vendor') {
                    this.vendorList = this.vendorList.filter((x) => x.catnam !== value);
                } else if (this.selectedItemType === 'outsourcing') {
                    this.outsourcingList = this.outsourcingList.filter((x) => x.catnam !== value);
                }
            }

            this.showEditDialog = false;
            this.updateData();
        },
    },
};
</script>
<style lang="scss" scoped="">
@import "@/assets/scss/vars.scss";
</style>
